import { useEffect } from 'react'
import { MessageEmitter } from './Emitter'
import uniqBy from 'lodash/uniqBy'
import { useApolloClient } from '../../../../api'
import { ConversationFragmentDoc } from '../../../../api/Fragments/Conversation.generated'
import {
  ConversationItemFragment,
  ConversationItemFragmentDoc,
} from '../../../../api/Fragments/ConversationItem.generated'
import {
  OnConversationDocument,
  OnConversationSubscription,
} from './OnConversation.generated'

export function useConversationRealTime() {
  const client = useApolloClient()

  useEffect(() => {
    const subscription = client
      .subscribe<OnConversationSubscription>({ query: OnConversationDocument })
      .subscribe(({ data }) => {
        const { conversation, userInteraction } = data.OnConversation

        if (
          userInteraction &&
          conversation.lastItem.sender.__typename !== 'Visitor'
        ) {
          MessageEmitter.dispatchEvent(
            new CustomEvent<ConversationItemFragment>('message', {
              detail: conversation.lastItem,
            })
          )
        }

        const messages = data.OnConversation.messages.map((_) =>
          client.cache.writeFragment({
            id: client.cache.identify(_),
            data: _,
            fragmentName: 'ConversationItem',
            fragment: ConversationItemFragmentDoc,
          })
        )

        client.cache.modify({
          fields: {
            Conversations(existing = []) {
              const ref = client.cache.writeFragment({
                id: client.cache.identify(conversation),
                data: conversation,
                fragmentName: 'Conversation',
                fragment: ConversationFragmentDoc,
              })

              return uniqBy([ref, ...existing], '__ref')
            },
          },
        })

        client.cache.modify({
          id: client.cache.identify(conversation),
          fields: {
            messages(existing) {
              return uniqBy([...messages, ...existing], '__ref')
            },
          },
        })
      })

    return () => subscription.unsubscribe()
  }, [client])
}
